/**
 * API configuration and backend selection
 */

export type BackendType = 'localhost' | 'server';

export interface BackendConfig {
    type: BackendType;
    baseUrl: string;
}

const BACKEND_CONFIGS: Record<BackendType, string> = {
    localhost: 'http://localhost:8000/api/v1',
    server: import.meta.env.VITE_SERVER_URL || 'https://api.praeviso.de/api/v1',
};

export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

class ApiConfig {
    private currentBackend: BackendType = 'localhost';

    setBackend(type: BackendType): void {
        this.currentBackend = type;
        localStorage.setItem('selectedBackend', type);
    }

    getBackend(): BackendType {
        const saved = localStorage.getItem('selectedBackend') as BackendType;
        if (saved && BACKEND_CONFIGS[saved]) {
            this.currentBackend = saved;
        }
        return this.currentBackend;
    }

    getBaseUrl(): string {
        return BACKEND_CONFIGS[this.currentBackend];
    }

    getConfig(): BackendConfig {
        return {
            type: this.currentBackend,
            baseUrl: this.getBaseUrl(),
        };
    }
}

export const apiConfig = new ApiConfig();

export const apiClient = {
    async fetch(endpoint: string, options?: RequestInit) {
        const response = await fetch(`${API_URL}${endpoint}`, {
            ...options,
            headers: {
                'Content-Type': 'application/json',
                ...options?.headers,
            },
        });

        if (!response.ok) {
            throw new Error(`API Error: ${response.statusText}`);
        }

        return response.json();
    },
};
